<ng-container [ngSwitch]="!!routeInfo">
  <ng-container *ngSwitchCase="true" [ngSwitch]="routeInfo.external">
    <a *ngSwitchCase="true" [attr.href]="routeInfo.route" target="_blank">
      <ng-template *ngTemplateOutlet="feedItem"></ng-template>
    </a>

    <i2g-router-link
      *ngSwitchDefault
      buttonStyle="plain"
      [route]="routeInfo.route"
      [navigationExtras]="routeInfo.navigationExtras"
    >
      <ng-template *ngTemplateOutlet="feedItem"></ng-template>
    </i2g-router-link>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <ng-template *ngTemplateOutlet="feedItem"></ng-template>
  </ng-container>
</ng-container>

<ng-template #feedItem>
  <app-basic-feed-list-item
    [type]="feedType"
    [header]="header"
    [description]="description"
    [descriptionTruncateThreshold]="2"
    [separateHeaderAndDescription]="true"
    [secondaryActionText]="'ACTION.DISMISS' | translate"
    [deletable]="true"
    (click)="onClick()"
    (onSecondaryAction)="onDismissClick()"
  >
  </app-basic-feed-list-item>
</ng-template>
